// Originally based on https://github.com/jprichardson/redux-watch
import { get as getValue } from "lodash-es";

export const watch = function(getState, objectPath, compare = (a, b) => a === b) {
    let currentValue = getValue(getState(), objectPath);
    return function w(fn) {
        return function() {
            const newValue = getValue(getState(), objectPath);
            if (!compare(currentValue, newValue)) {
                const oldValue = currentValue;
                currentValue = newValue;
                fn(newValue, oldValue, objectPath);
            }
        };
    };
};
